export const endpoint = {
  loadPermission: 'Channel',
  loadConsents: (recipientId: number) => `Recipient/${recipientId}/channel`,
  loadConsent: (id: number, recipientId: number) => `Recipient/${recipientId}/channel/${id}`,
  deleteConsent: (id: number, recipientId: number) => `Recipient/${recipientId}/channel/${id}`,
  verifyCode: (recipientId: number) => `Recipient/${recipientId}/channel/sendVerificationCode`,
  addSubscription: (recipientId: number) => `Recipient/${recipientId}/channel`,
  updateSubscription: (id: number, recipientId: number) => `Recipient/${recipientId}/channel/${id}`
};
